<template>
  <div>
    {{ locale === "en" && item.title_en ? item.title_en : item.title }}
    <template v-if="item.price !== null && item.price !== undefined">
      {{ ` (${item.price} €)` }}</template
    >
  </div>
</template>

<script>
import { i18n } from "../../plugins/i18n";

export default {
  props: ["item"],
  computed: {
    locale() {
      return i18n.locale;
    },
  },
};
</script>

<style></style>
